import React from 'react';

import { Link } from 'react-router-dom';

import { Page } from 'components/modules/AutoruLayout/Page/Page';
import { Loading } from 'components/modules/Insurance/components/Loading/Loading';
import { Button } from 'components/uikit/Button/Button';

import * as S from '../../Insurance.styles';

import { PageBottom } from '../PageBottom/PageBottom';
import { Stepper } from '../Stepper/Stepper';

import { Form } from './components/Form/Form';
import { usePolicyHolderPresenter } from './PolicyHolder.presenter';

export const Policyholder = () => {
  const presenter = usePolicyHolderPresenter();

  return (
    <Page
      aside={<Stepper />}
      bottom={
        !presenter.loading && (
          <PageBottom>
            <Button as={Link} size="m" theme="3" to={presenter.previousPagePath}>
              Назад
            </Button>
            <Button disabled={presenter.disabled} size="m" theme="1" onClick={presenter.onSubmit}>
              Продолжить
            </Button>
          </PageBottom>
        )
      }
    >
      {presenter.loading && <Loading />}
      {!presenter.loading && (
        <>
          <Form
            header={
              <S.Switcher
                disabled={presenter.disabled}
                label="Страхователь"
                value={presenter.ownerIsInsurer}
                onChange={presenter.onChangeOwnerIsInsurer}
              />
            }
            title={presenter.ownerIsInsurer ? 'Страхователь' : 'Собственник'}
            isOwnerForm
          />
          {!presenter.ownerIsInsurer && <Form title="Страхователь" />}
        </>
      )}
    </Page>
  );
};
